import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["downloadName", "thumbnail", "url", "block", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { DixuRow, DixuCol } from "../DixuGrid/DixuGrid";
import DixuImage from "../DixuImage/DixuImage";
import DixuText from "../DixuText/DixuText";
import DixuButton from "../DixuButton/DixuButton";
import { get } from "../../services/ApiService";
import { downloadUrl } from "../../utils/FileUtils";
const DixuDownloadFileButton = _ref => {
  let {
      downloadName,
      thumbnail,
      url,
      block,
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-download-file-button', {
    'dixu-download-file-button--block': block
  }, 'bg-2-2', 'border-radius-xs', className);
  return /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({}, rest), {}, {
    className: classes,
    onClick: async () => {
      const blob = await get(url, {
        responseType: 'blob'
      });
      downloadUrl(blob, {
        downloadName,
        createObjectURL: true
      });
    },
    external: true
  }), /*#__PURE__*/React.createElement(DixuRow, {
    justify: "space-between",
    align: "middle",
    gutter: 16,
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: 8,
    wrap: false
  }, thumbnail && /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuImage, {
    src: thumbnail,
    width: "48",
    aspectRatio: "1:1",
    borderRadius: "xs"
  })), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-8"
  }, children)))), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuButton, {
    type: "outline",
    modifierType: "circle",
    size: "sm",
    icon: /*#__PURE__*/React.createElement(DownloadOutlined, null),
    tag: "span"
  }))));
};
DixuDownloadFileButton.defaultProps = {
  thumbnail: undefined,
  block: false
};
export default DixuDownloadFileButton;